import React from 'react'
import { Button, Icon, Tooltip } from 'antd'
import { useTranslation } from 'react-i18next'
import BulkActionBarHolder from '../styles/bulkActionBarStyle'

// Simple white banner shown when items (ads and/or folders) are selected.
// Sticky to the top. Left: an X to clear the selection (tooltip). Right: delete.
// `count` is the combined total of selected ads + folders.
const BulkActionBar = ({ count = 0, onDelete, onClear, deleteDisabled = false }) => {
  const { t } = useTranslation()

  if (!count) return null

  return (
    <BulkActionBarHolder>
      <div className="left">
        <Tooltip title={t('Clear selection')}>
          <Icon type="close" className="clear-icon" onClick={onClear} />
        </Tooltip>
        <span className="count">{t('{{count}} selected', { count })}</span>
      </div>

      <Tooltip title={t('Archive {{count}} items', { count })}>
        <Button type="danger" disabled={deleteDisabled} onClick={() => onDelete && onDelete()}>
          {t('Archive items')} <Icon type="delete" />
        </Button>
      </Tooltip>
    </BulkActionBarHolder>
  )
}

export default BulkActionBar
